
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  name: "TempNavigation",
  components: {},
})
export default class TempNavigation extends Vue {
  navTabs = [
    {
      label: "首页",
      children: ["/temp/home"],
      default: "/temp/home",
      index: 0,
    },
    {
      label: "政策库",
      children: [],
      default: "/temp/home",
      index: 1,
    },
    {
      label: "政策指南",
      children: [],
      default: "/temp/home",
      index: 2,
    },
    {
      label: "政策大讲堂",
      children: [],
      default: "/temp/home",
      index: 3,
    },
  ];
  activeName = "page0";
  handleClick(e: any) {
    this.activeName = "page0";
  }
  created() {
    this.fixTab();
  }
  fixTab() {
    const currentRouter = this.$route.path;
    const currentActive = this.navTabs.find((item: any) =>
      item.children.includes(currentRouter)
    );
    this.activeName = `page${currentActive?.index}`;
  }
  @Watch(`$route`)
  routechange(to: any, from: any) {
    this.fixTab();
  }
}
